import { useRouter } from "vue-router";

export function useNavigation() {
  const router = useRouter();

  const navigateToSection = (sectionId) => {
    router.push({ name: "home", query: { scroll: sectionId } });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return { navigateToSection, scrollToSection };
}
